import { Component, EventEmitter, Input, Output } from '@angular/core';
import { GridPaginationBase } from './grid-pagination-base';

@Component({ standalone: false, selector: 'app-shared-base-grid', templateUrl: './grid.component.html', styleUrls: ['./grid.component.scss'] })
export class BaseGridComponent extends GridPaginationBase<any> {
  private _data: any[] = [];
  public filteredData: any[] = [];
  public placeholderSearch = 'Nombre';
  @Output() readonly onRefrescarTabla = new EventEmitter<void>();
  @Output() readonly onSelected = new EventEmitter<any>();
  @Input() public loading: any;
  @Input() public columnDefs: any[] = [];
  @Input() set data(value: any) {
    this._data = Array.isArray(value) ? value : [];
    this.aplicarFiltro();
  }

  get displayedColumns(): any[] {
    return this.columnDefs || [];
  }

  value(row: any, column: any): any {
    if (column.valueGetter) {
      return column.valueGetter({ data: row });
    }
    return row[column.field];
  }

  refrescarTabla(): void { this.onRefrescarTabla.emit(); }
  protected aplicarFiltro(): void {
    const filtro = this.terminoBusqueda.toLocaleLowerCase();
    this.filteredData = this._data.filter(row => !filtro || this.displayedColumns.some(column => String(this.value(row, column) ?? '').toLocaleLowerCase().includes(filtro)));
    this.actualizarPaginacion(this.filteredData.length);
  }
}
